var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{attrs:{"color":"transparent"}},[_c('v-row',_vm._l((_vm.widgets),function(widget,i){return _c(widget.name,_vm._b({key:i,tag:"v-component"},'v-component',widget.bind,false))}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }